import { MainInner } from "@/styles/global";
import { Paragraph, h2 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)<{ $icon: string }>`
  align-items: ${({ $icon }) => ($icon === "logo" ? "center" : "flex-start")};
  gap: ${({ $icon }) => ($icon === "info" ? "16px" : "24px")};
  text-align: ${({ $icon }) => ($icon === "logo" ? "center" : "left")};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
    align-items: ${({ $icon }) => ($icon === "info" ? "flex-start" : "center")};
    padding: 100px 116px;
    gap: ${({ $icon }) => ($icon === "info" ? "48px;" : "64px;")};
    text-align: left;
  }
`;

const IconWrapper = styled.div<{ $icon: string }>`
  svg {
    max-height: 70px;
    max-width: 70px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $icon }) =>
      $icon === "logo" &&
      `
    svg {
      max-height: 102px;
      max-width: 102px;
    }
  `}
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    svg {
      max-height: 235px;
      max-width: 235px;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 660px;
`;

const Title = styled(h2)<{ $bgColor: string }>`
  color: ${({ $bgColor, theme }) =>
    $bgColor === "standard" || $bgColor === "purple"
      ? theme.colors.coreLight
      : theme.colors.textHeading};
`;

const Text = styled(Paragraph)<{ $bgColor: string }>`
  color: ${({ $bgColor, theme }) =>
    $bgColor === "standard" || $bgColor === "purple"
      ? theme.colors.coreLight
      : theme.colors.textHeading};
`;

const LinkWrapper = styled.div<{ $icon: string }>`
  display: flex;
  justify-content: ${({ $icon }) =>
    $icon === "logo" ? "center" : "flex-start"};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    align-items: start;
    justify-content: flex-start;
  }
`;

const S = {
  Inner,
  Title,
  IconWrapper,
  TextWrapper,
  Text,
  LinkWrapper,
};

export default S;
